<template>
  <article :class="getClass" :id="'tease-' + item.id">
    <div class="tease-column" data-enable-hover data-hover-target="a">
      <a :href="item.link">
        <div :class="getImageClass">
          <div class="perfect-square">
            <img
              v-if="imgSrc !== ''"
              :src="imgSrc"
              :alt="item.image.alt"
              :style="item.image.style ?? ''"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        <p class="data">
          <span class="post-cat" v-if="getString(itemStore.title)">{{
            getString(itemStore.title)
          }}</span>
          <span class="post-date" v-if="itemStore.showDate && !itemIsEvent">{{
            showDate(item.date)
          }}</span>
          <span class="post-tag" v-if="getString(itemStore.tag)">{{
            getString(itemStore.tag)
          }}</span>
        </p>
        <h3 class="post-title">{{ item.title }}</h3>
        <p class="teaselink"><i class="far fa-arrow-right"></i></p>
      </a>
    </div>
  </article>
</template>

<script setup lang="ts">
import { useItemStore } from "@/stores/items";
import type { Item } from "@/stores/items";
import { computed } from "vue";

const itemStore = useItemStore();

const props = defineProps<{
  item: Item;
  nr: number;
}>();

const showDate = (date: string) => {
  const d = new Date(date);
  return d.toLocaleDateString("fi");
};

const getString = (value: string) => {
  if (value === "primary") {
    if (props.item.primary.length > 0) {
      return props.item.primary[0].name;
    }
    return "";
  } else if (value === "secondary") {
    let text = "";
    props.item.secondary.forEach((term) => {
      if (text.length) {
        text += ", ";
      }
      text += term.name;
    });
    return text;
  }
  return value;
};

const itemIsEvent = computed(() => {
  if (props.item.primary.length === 0) {
    return false;
  }
  const slug = props.item.primary[0].slug;
  return (
    props.item.primary.length > 0 &&
    (slug === "evenemang" || slug === "event" || slug === "tapahtuma")
  );
});

const getClass = computed(() => {
  let className = "tease";
  className += " tease-" + itemStore.type;
  if (props.item.primary) {
    props.item.primary.forEach((term) => {
      className += " tease-primary-" + term.slug;
    });
  }
  if (props.item.secondary) {
    props.item.secondary.forEach((term) => {
      className += " tease-secondary-" + term.slug;
    });
  }
  if (itemStore.showDate && !itemIsEvent.value) {
    className += " tease-has-date";
  }
  className += " tease-nr-" + props.nr;
  return className;
});

const getImageClass = computed(() => {
  let className = "image-div";
  if (props.item.image.medium) {
    className += " has-image";
  } else {
    className += " placeholder";
  }
  return className;
});

const imgSrc = computed(() => {
  if (props.item.image.medium && props.nr !== 0) {
    return props.item.image.medium;
  }
  if (props.item.image.large && props.nr === 0) {
    return props.item.image.large;
  }
  if (props.item.image.medium) {
    return props.item.image.medium;
  }
  return "";
});
</script>
